import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { jsx as _jsx } from "react/jsx-runtime";
const DocumentsUpdatedAtCell = ({
  searchResult
}) => {
  const updatedAt = searchResult.get('updatedAt');
  if (!updatedAt) {
    return null;
  }
  return /*#__PURE__*/_jsx(FormattedDateTime, {
    format: "ll",
    value: updatedAt
  });
};
export default DocumentsUpdatedAtCell;